import whatInput from 'what-input';
import './foundation-explicit-pieces';
import './mobile-menu.js';
import './cookie-bar.js';
import './video.js';
import './scrollMagic.js';
import './top-bar.js';

$(document).ready(function() {

    if ( $('.blogContent').length > 0 ) {
        var top = $('.blogContent').offset().top;
        $(window).on('scroll', function() {
            if ($(window).scrollTop() > top + 60) {
                $('.blogContent').addClass('prefixed');
            }
            else {
                $('.blogContent').removeClass('prefixed');
            }
            if ($(window).scrollTop() > top + 260) {
                $('.blogContent').addClass('fixed');
            }
            else {
                $('.blogContent').removeClass('fixed');
            }
        });
    }

    
    var n = new ScrollMagic.Controller;
    
    $('.magicscroll_block').each(function(){
        
        var t =  new TimelineMax()
        .fromTo($(this).find('.magicscroll_block__head'),.5,{x:-2000},{x:0, delay:.5, ease:Circ.easeOut})
        .fromTo($(this).find('.magicscroll_block__lead'),.5,{x:2000},{x:0,ease:Circ.easeOut});
        
        var bg_in = new TweenMax.fromTo(this, 1, {autoAlpha: 0.8}, {autoAlpha:1});
        var bg_out = new TweenMax.fromTo(this, 1, {autoAlpha: 1}, {autoAlpha:0.8});
        
        TweenMax.set(this, {autoAlpha:0.8});
        
        new ScrollMagic.Scene({triggerElement:this}).offset(-100).setTween(t).addTo(n);
        new ScrollMagic.Scene({triggerElement:this, duration:100}).setTween(bg_in).addTo(n);
        new ScrollMagic.Scene({triggerElement:this, triggerHook:"onLeave", duration:100}).offset(100).setTween(bg_out).addTo(n);
    });
        
    if ($('.magicscroll_2block').length > 0) {
        var t2 =  new TimelineMax()
            .fromTo('.magicscroll_2block .column:nth-child(1) h2',.5,{y:-500},{y:0, ease:Circ.easeOut})
            .fromTo('.magicscroll_2block .column:nth-child(1) p',.5,{y:500},{y:0, delay:.1, ease:Circ.easeOut})
            .fromTo('.magicscroll_2block .column:nth-child(2) h2',.5,{y:-500},{y:0, delay:.2, ease:Circ.easeOut}) 
            .fromTo('.magicscroll_2block .column:nth-child(2) p',.5,{y:500},{y:0, delay:.3, ease:Circ.easeOut});  
        new ScrollMagic.Scene({triggerElement:".magicscroll_2block"}).offset(-100).setTween(t2).addTo(n);
    }

    $('.article').each(function(){
            
        var i=(new TimelineMax)
                .fromTo(this,.3,{y:40},{y:0,autoAlpha:1,ease:Circ.easeOut})
                .fromTo($(this).find('img'),.3,{y:40, autoAlpha:0},{y:0, autoAlpha:1, delay:.1, ease:Circ.easeOut})
                .fromTo($(this).find('h3'),.3,{y:20, autoAlpha:0},{y:0, autoAlpha:1, delay:.2, ease:Circ.easeOut})
                .fromTo($(this).find('p'),.3,{y:20, autoAlpha:0},{y:0, autoAlpha:1, delay:.3, ease:Circ.easeOut})
        TweenMax.set(this,{autoAlpha:0});
        new ScrollMagic.Scene({triggerElement:this}).offset(-100).setTween(i).addTo(n)
    });

    $('.case-reel__case').each(function(){
        var i=(new TimelineMax)
                .fromTo(this,.3,{y:40},{y:0,autoAlpha:1,ease:Circ.easeOut})
                .fromTo($(this).find('img'),.3,{y:40, autoAlpha:0},{y:0, autoAlpha:1, delay:.1, ease:Circ.easeOut})
                .fromTo($(this).find('.case-reel__case-info'),.3,{y:20, autoAlpha:0},{y:0, autoAlpha:1, delay:.2, ease:Circ.easeOut})
        TweenMax.set(this,{autoAlpha:0});
        new ScrollMagic.Scene({triggerElement:this}).offset(-100).setTween(i).addTo(n)
    });

    $('.method-blocks__row:even').each(function(){
        var i=(new TimelineMax)
                .fromTo($(this).find('.method-blocks__box__round'),.3,{x:-50, autoAlpha:0},{x:0, autoAlpha:1, delay:0, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__box__line'),.3,{x:-30, autoAlpha:0},{x:0, autoAlpha:1, delay:.1, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__box'),.3,{x:-999, autoAlpha:0},{x:0, autoAlpha:1, delay:.2, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__icon'),.3,{x:-50, autoAlpha:0},{x:0, autoAlpha:1, delay:.3, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__textblock'),.3,{x:-50, autoAlpha:0},{x:0, autoAlpha:1, delay:.4, ease:Circ.easeOut})
        //TweenMax.set(this,{autoAlpha:0});
        new ScrollMagic.Scene({triggerElement:this}).offset(-100).setTween(i).addTo(n)
    });

    $('.method-blocks__row:odd').each(function(){
        var i=(new TimelineMax)
                .fromTo($(this).find('.method-blocks__box__round'),.3,{x:50, autoAlpha:0},{x:0, autoAlpha:1, delay:0, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__box__line'),.3,{x:30, autoAlpha:0},{x:0, autoAlpha:1, delay:.1, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__box'),.3,{x:999, autoAlpha:0},{x:0, autoAlpha:1, delay:.2, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__icon'),.3,{x:50, autoAlpha:0},{x:0, autoAlpha:1, delay:.3, ease:Circ.easeOut})
                .fromTo($(this).find('.method-blocks__textblock'),.3,{x:50, autoAlpha:0},{x:0, autoAlpha:1, delay:.4, ease:Circ.easeOut})
        //TweenMax.set(this,{autoAlpha:0});
        new ScrollMagic.Scene({triggerElement:this}).offset(-100).setTween(i).addTo(n)
    });
    
});

$(document).foundation();
